/* istanbul ignore file */
import type {BooleanStyleParamsKeys} from '../stylesParams';
import type {ShouldRenderVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {getProductPageButtonContainerShouldRenderVars} from '../../../productPage/components/ProductPageButtonsContainer/ProductPageButtonContainer.cssVars';
import {getResponsiveLayoutShouldRenderVars} from '../../../productPage/components/Layouts/ResponsiveLayout/ResponsiveLayout.cssVars';

export type ShouldRenderVarsKeys = keyof ReturnType<typeof getShouldRenderVars> | BooleanStyleParamsKeys;

export const getShouldRenderVars = (shouldRenderVarsFnParams: ShouldRenderVarsFnParams) => {
  return {
    ...getProductPageButtonContainerShouldRenderVars(shouldRenderVarsFnParams),
    ...getResponsiveLayoutShouldRenderVars(shouldRenderVarsFnParams),
  };
};
